module.exports = __webpack_public_path__ + "static/media/Results-3.f5c3841b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/proof/Results-3.jpg
// module id = 366
// module chunks = 0